module.exports = __webpack_public_path__ + "static/media/nodeb.611d2440.png";